<template>
  <AppSection id="languages" :title="$getConst.pages.scope.scope_logs" type="page">
    <b-form-group id="language" :label="$t($getConst.pages.scope.scopes)" label-for="language-input">
      <multiselect
        v-model="scope"
        track-by="id"
        label="name"
        :placeholder="$t(this.$getConst.pages.form.select_option)"
        :options="$store.getters['auth/allScopes']"
        :show-labels="false"
        :searchable="true"
        @input="changeScope"
      >
        <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
      </multiselect>
    </b-form-group>
    <AppDataTable
      ref="logsTable"
      :fields="fields"
      :end-point="endPoint"
      sort-by="created_at"
      sort-desc
    >

      <template v-slot:log_name="log_name" class="text-break">
        <div style="min-width: 10rem" class="text-break">{{log_name.data}}</div>
      </template>

      <template v-slot:causer_id="item">
        <template v-if="item.data!=null">
          {{item.data.name}}
        </template>
      </template>

      <template v-slot:properties="item">
        <b-link @click="showPropertiesDetails(item.row)" v-b-tooltip.hover
                  :title="$t($getConst.pages.button.show_more)"><i :class="$getConst.icons.externalLink + ' text-primary'"></i></b-link>
      </template>

      <template v-slot:details="item">
        <template v-if="item.data.length > 10">
          {{ item.data.substr(0, 30)  }} ...
          <b-link @click="showDetails(item.row)" v-b-tooltip.hover
                  :title="$t($getConst.pages.button.show_more)"><i :class="$getConst.icons.externalLink + ' text-primary'"></i></b-link>
          </template>
      </template>
      <template v-slot:created_at="item">
        {{formatDate(item.data)}}
      </template>
    </AppDataTable>
    <ShowLogPropertiesDetailsModal v-if="log" :log="log" :id="propertiesDetailsModal" size="xl"></ShowLogPropertiesDetailsModal>
    <ShowLogDetailsModal v-if="log" :log="log" :id="detailsModal" size="xl"></ShowLogDetailsModal>
  </AppSection>
</template>

<script>
  import AppSection from "../../../../components/common/sections/AppSection";
  import AppDataTable from "../../../../components/common/table/AppDataTable";
  import {usersInScopes} from "../../../../api/scopes.api";
  import ShowLogPropertiesDetailsModal from "./ShowLogPropertiesDetailsModal";
  import ShowLogDetailsModal from "./ShowLogDetailsModal";
  import {formatDateByScope} from "../../../../shared/services/date";

  export default {
    name: "index",
    components: {ShowLogDetailsModal, ShowLogPropertiesDetailsModal, AppSection, AppDataTable},
    data() {
      return {
        endPoint: null,
        users: [],
        fields: [
          {key: 'log_name', label: 'name', sortable: true, filterable: true},
          {key: 'description', sortable: true, filterable: true},
          {key: 'causer_id', label: 'User', sortable: true, filterable: true},
          {key: 'properties', sortable: false, filterable: false},
          {key: 'status', sortable: true, filterable: true},
          {key: 'details', sortable: true, filterable: true},
          {key: 'created_at', sortable: true, filterable: 'date'},
        ],
        scope: null,
        scopeIds: null,
        propertiesDetailsModal: 'properties-details-modal',
        detailsModal: 'details-modal',
        log: null
      }
    },
    created() {
      this.$store.getters['auth/allScopes'].forEach(scope => {
        this.scopeIds = this.scopeIds + "," + scope.id;
      });
      this.scopeIds = this.scopeIds.substring(5)
      this.endPoint = '/activityLogs/' + this.scopeIds;
      this.usersInScopes(this.scopeIds);
    },
    methods: {
      usersInScopes(scopesId) {
        usersInScopes(scopesId).then(listOfUsers => {
          this.users = listOfUsers.data;
          this.updateFields(this.users);
        })
      },
      updateFields(users) {
        this.fields[2].filterable = users.map(user => {
          return {value: user.id, text: user.firstName + ' ' + user.lastName};
        });
      },
      changeScope() {
        if (this.scope) {
          this.usersInScopes(this.scope.id);
          this.endPoint = '/activityLogs/' + this.scope.id;
        } else {
          this.usersInScopes(this.scopeIds);
          this.endPoint = '/activityLogs/' + this.scopeIds;
        }
      },
      showPropertiesDetails(log) {
        this.log = log;
        this.$nextTick(() => this.$bvModal.show(this.propertiesDetailsModal));
      },
      showDetails(log) {
        this.log = log;
        this.$nextTick(() => this.$bvModal.show(this.detailsModal));
      },
      formatDate(date) {
        const formatD = formatDateByScope(date, this.$store.getters["auth/scopeDefault"].format_date, this.scope);
        return formatD;
      },
    },
  }
</script>
